import React from 'react'

const DeleteNotificationModal = ({ changeStatus, onCancel }: { changeStatus: Function, onCancel: Function }) => {
    return (
        <div className="modal fade" id="delete-notification" aria-labelledby="statusModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content bg-white">
                    <div className="modal-body pt-4 pb-3 text-center main-msg">
                        <p className='mb-0'>{"Are you sure you want to delete this?"}</p>
                    </div>
                    <div className="modal-footer justify-content-center border-top-0 pb-4">
                        <button type="button" className="grey-outline-btn mr-3" data-bs-dismiss="modal" onClick={() => onCancel()}>No</button>
                        <button type="button" className="outline-icon-btn" data-bs-dismiss="modal" onClick={() => changeStatus()}>Yes</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeleteNotificationModal